/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  container: {
    type: [String, Function],
    "default": function _default() {
      return function () {
        return window;
      };
    }
  },
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  offsetBottom: {
    type: Number,
    "default": 0
  },
  offsetTop: {
    type: Number,
    "default": 0
  },
  zIndex: {
    type: Number
  },
  onFixedChange: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
